/* libs */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { isEmpty } from "lodash";

/* components */
import NavItem from "./NavItem";
import SidebarTitle from "./SidebarTitle";
import SidebarSection from "./SidebarSection";
import UserHasPermission from "../../helpers/validation/userHasPermission";
import UserIsGlobal from "../../helpers/validation/userIsGlobal";

class AppNav extends Component {
	componentDidMount() {
		const { match, experiencesActions } = this.props;
		const { appKey } = match.params;
		experiencesActions.loadExperiences(appKey);
	}

	renderExperience = exp => {
		const { appKey } = this.props.match.params;
		const { user } = this.props;
		let extra = "";
		if (!UserHasPermission(user, "structure")) {
			extra = "/pages";
		}
		return <NavItem key={exp.id} linkTo={`/apps/${appKey}/experiences/${exp.id}${extra}`} text={exp.name} />;
	};

	shouldComponentUpdate(nextProps) {
		const { match, experiencesActions } = this.props;
		let { appKey } = match.params;
		let newAppKey = nextProps.match.params.appKey;
		if (appKey !== newAppKey) {
			experiencesActions.loadExperiences(newAppKey);
		}
		return true;
	}

	reloadExperiences = () => {
		let { appKey } = this.props.match.params;
		this.props.experiencesActions.loadExperiences(appKey);
	};

	deleteExperience = (id, name) => {
		this.props.globalActions.deleteItem("/experiences/" + id, this.reloadExperiences, this.logError, name);
	};

	render() {
		const {
			user,
			match: {
				params: { appKey },
			},
			appConfig: { appConfig },
			experiences: { experiences },
			responsiveActions: { hideSideMenu },
		} = this.props;

		const basePath = `/apps/${appKey}`;

		const userIsStructure = UserHasPermission(user, "structure");
		const userIsFull = UserHasPermission(user, "full");
		const userIsGlobal = UserIsGlobal(user);

		const showQAManager = userIsFull && !isEmpty(appConfig) && appConfig.serviceAccountKey;

		return (
			<div>
				<SidebarTitle to="/apps" title="My Apps" onClick={() => hideSideMenu()} />
				<SidebarSection
					to={userIsFull ? `${basePath}/experiences/new` : null}
					title="Experiences"
					items={experiences}
					itemPath={`${basePath}/experiences`}
					itemSuffix={!userIsFull ? "/pages" : null}
					showOptions={userIsFull}
					deleteItem={userIsFull ? this.deleteExperience : null}
				/>
				{userIsFull && (
					<SidebarSection
						to={`${basePath}/integrations/new`}
						gridPath={`${basePath}/integrations`}
						title="Integrations"
					/>
				)}
				{userIsStructure && (
					<SidebarSection to={`${basePath}/themes/new`} gridPath={`${basePath}/themes`} title="Themes" />
				)}
				<SidebarSection title="Content">
					<NavItem linkTo={`/apps/${appKey}/posts`} text="Posts" />
					<NavItem linkTo={`/apps/${appKey}/sessions`} text="Sessions" />
					{showQAManager && <NavItem linkTo={`/apps/${appKey}/qa`} text="Q&A Manager" />}
				</SidebarSection>
				{userIsFull && (
					<SidebarSection gridPath={`${basePath}/users`} to={`${basePath}/users/new`} title="Users" />
				)}
				{userIsFull && <SidebarSection gridPath={`${basePath}/navigation`} title="Navigation" />}

				<SidebarSection
					gridPath={`${basePath}/notifications`}
					to={`${basePath}/notifications/new`}
					title="Notifications"
				>
					{userIsFull && <NavItem linkTo={`/apps/${appKey}/topics`} text="Topics" />}
				</SidebarSection>
				{userIsFull && <SidebarSection title="Settings" gridPath={`${basePath}/settings`} />}
				{userIsGlobal && <SidebarSection title="App Config" gridPath={`${basePath}/config`} />}
			</div>
		);
	}
}
AppNav.propTypes = {
	appConfig: PropTypes.object,
	experiences: PropTypes.object,
	experiencesActions: PropTypes.object,
	globalActions: PropTypes.object,
	match: PropTypes.object,
	responsiveActions: PropTypes.object,
	user: PropTypes.object,
};
export default AppNav;
